<ion-content [fullscreen]="true">
  <div class="action-buttons">
    <ion-button color="danger" size="small" (click)="closeProfile()">Close</ion-button>
    <ion-button *ngIf="!isEditMode" (click)="isEditMode = true" color="success" size="small">Edit</ion-button>
    <ion-button *ngIf="isEditMode" (click)="saveProfile()" color="success" size="small">Save</ion-button>
  </div>

  <div *ngIf="profile?.ProfileId > 0 || isNewAppUser === true">
    <div class="profile-image">
      <div class="image-container">
        <ion-img *ngIf="profile.ImageSrc" [src]="profile.ImageSrc"></ion-img>
        <ion-img *ngIf="!profile.ImageSrc" src="assets/images/default.png"></ion-img>
        <ion-fab *ngIf="environment.IsAppInReview === false" class="top-corner" (click)="openCamera()">
          <ion-fab-button size="small">
            <ion-icon name="camera-outline"></ion-icon>
          </ion-fab-button>
        </ion-fab>
      </div>
      <br>
      <ion-label aria-label="profile name" class="profile-name">{{profile.ProfileName}}</ion-label>
      <br>
      <div class="quick-actions">
        <a *ngIf="profile.Mobile1" href="tel:{{profile.Mobile1}}">
          <ion-icon name="call-outline"></ion-icon></a>
        <a *ngIf="profile.Mobile1" [attr.href]="'sms:'+profile.Mobile1 | safeUrl">
          <ion-icon name="chatbubble-ellipses-outline"></ion-icon></a>
        <a *ngIf="profile.FullAddress"><ion-icon name="map-outline"
            (click)="openMaps(profile.FullAddress)"></ion-icon></a>
        <a *ngIf="profile.PrimaryEmail" href="mailto:{{profile.PrimaryEmail}}">
          <ion-icon name="mail-outline"></ion-icon></a>
        <ion-icon *ngIf="profile.ProfileId" name="id-card-outline" (click)="downloadvCard()"></ion-icon>
        <ion-icon name="information-circle-outline" (click)="isProfileInfoOpen = true"></ion-icon>
      </div>
      <div class="quick-actions">
        {{profile?.ServiceName}}
      </div>
    </div>

    <ion-popover [isOpen]="isProfileInfoOpen" (didDismiss)="isProfileInfoOpen = false">
      <ng-template>
        <ion-item>
          <ion-label aria-label="Family Id" class="date-field">
            <span>Family Id:</span> {{profile.FamilyId}}
          </ion-label>
        </ion-item>
      </ng-template>
    </ion-popover>

    <ion-accordion-group [multiple]="true" [value]="['BasicInfo', 'Contact', 'Service', 'Comment']">
      <ion-accordion value="BasicInfo" [disabled]="!isEditMode">
        <ion-item slot="header" color="light">
          <ion-label aria-label="Basic Info">Basic Info</ion-label>
        </ion-item>
        <div class="ion-no-padding" slot="content">
          <ion-item>
            <ion-label aria-label="First Name">
              <ion-input label="First Name" [(ngModel)]="profile.FirstName" labelPlacement="floating" type="text"
                placeholder="First Name"></ion-input>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>
              <ion-input label="Middle Name" [(ngModel)]="profile.MidName" labelPlacement="floating" type="text"
                placeholder="Middle Name"></ion-input>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>
              <ion-input label="Last Name" [(ngModel)]="profile.LastName" labelPlacement="floating" type="text"
                placeholder="Last Name"></ion-input>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-select label="Gender" interface="action-sheet" placeholder="Gender" [(ngModel)]="profile.GenderId">
              <ion-select-option *ngFor="let t of lstGenders" [value]="t.value">{{t.label}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-label aria-label="Birth Date" class="date-field">
              <span>Birth Date</span>
              <ion-datetime-button datetime="birthdate"></ion-datetime-button>
              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  <ion-datetime presentation="date" id="birthdate" [(ngModel)]="profile.BirthDate"></ion-datetime>
                </ng-template>
              </ion-modal>
            </ion-label>
          </ion-item>
          <ion-item *ngIf="isEditMode || (!isEditMode && profile.MarriageDate !== null)">
            <ion-label aria-label="Marriage Date">Marriage Date</ion-label>
            <ion-input value="{{ profile.MarriageDate | date: 'MM/dd/yyyy'}}" id="marriagedate" class="ion-text-end"
              disabled="true"></ion-input>
            <ion-popover trigger="marriagedate" size="auto">
              <ng-template>
                <ion-datetime presentation="date" #marriagedate (ionChange)="setDateToValue(marriagedate.value)">
                </ion-datetime>
              </ng-template>
            </ion-popover>
          </ion-item>
          <!-- <ion-item>
            <ion-label class="date-field">
              <span>Marriage Date</span>
              <ion-datetime-button datetime="marriagedate"></ion-datetime-button>
              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  <ion-datetime presentation="date" id="marriagedate" [(ngModel)]="profile.MarriageDate"></ion-datetime>
                </ng-template>
              </ion-modal>
            </ion-label>
          </ion-item> -->
          <ion-item *ngIf="isEditMode || (!isEditMode && profile.RelationTypeId > 0)">
            <ion-select label="Relation Type" interface="action-sheet" placeholder="Relation Type"
              [(ngModel)]="profile.RelationTypeId">
              <ion-select-option *ngFor="let t of lstRelationTypes" [value]="t.value">{{t.label}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item *ngIf="isEditMode || (!isEditMode && profile.EducationLevelId > 0)">
            <ion-select label="Education" interface="action-sheet" placeholder="Education"
              [(ngModel)]="profile.EducationLevelId">
              <ion-select-option *ngFor="let t of lstEducations" [value]="t.value">{{t.label}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item *ngIf="isEditMode || (!isEditMode && profile.OccupationId > 0)">
            <ion-select label="Occupation Status" interface="action-sheet" placeholder="Occupation Status"
              [(ngModel)]="profile.OccupationId">
              <ion-select-option *ngFor="let t of lstOccupations" [value]="t.value">{{t.label}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item *ngIf="isEditMode || (!isEditMode && profile.ProfessionId > 0)">
            <ion-select label="Profession" interface="action-sheet" placeholder="Profession"
              [(ngModel)]="profile.ProfessionId">
              <ion-select-option *ngFor="let t of lstProfessions" [value]="t.value">{{t.label}}</ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion value="Contact" [disabled]="!isEditMode">
        <ion-item slot="header" color="light">
          <ion-label>Contact</ion-label>
        </ion-item>
        <div class="ion-no-padding" slot="content">
          <ion-item>
            <ion-input label="Email" [(ngModel)]="profile.PrimaryEmail" labelPlacement="floating" type="email"
              aria-label="Email" placeholder="Email"></ion-input>

            <a slot="end" *ngIf="profile.Mobile1" href="mailto:{{profile.PrimaryEmail}}">
              <ion-icon name="mail-outline"></ion-icon></a>
          </ion-item>
          <ion-item>
            <ion-input label="Mobile1" labelPlacement="floating" type="text" placeholder="Mobile1"
              [(ngModel)]="profile.Mobile1" minlength="10" maxlength="10" (ionInput)="onMobile1Input($event)"
              #mobile1Input></ion-input>
            <a slot="end" *ngIf="profile.Mobile1" href="tel:{{profile.Mobile1}}">
              <ion-icon name="call-outline"></ion-icon></a>
            <a slot="end" *ngIf="profile.Mobile1" [attr.href]="'sms:'+profile.Mobile1 | safeUrl">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon></a>
          </ion-item>
          <ion-item>
            <ion-input label="Mobile2" labelPlacement="floating" type="text" placeholder="Mobile2"
              [(ngModel)]="profile.Mobile2" minlength="10" maxlength="10" (ionInput)="onMobile2Input($event)"
              #mobile2Input></ion-input>
            <a slot="end" *ngIf="profile.Mobile2" href="tel:{{profile.Mobile1}}">
              <ion-icon name="call-outline"></ion-icon></a>
            <a slot="end" *ngIf="profile.Mobile2" [attr.href]="'sms:'+profile.Mobile2 | safeUrl">
              <ion-icon name="chatbubble-ellipses-outline"></ion-icon></a>
          </ion-item>
          <ion-item>
            <ion-input label="Street" [(ngModel)]="profile.StreetName" labelPlacement="floating"
              placeholder="Street"></ion-input>
            <ion-icon name="map-outline" (click)="openMaps(profile.FullAddress)"></ion-icon>
          </ion-item>
          <ion-item>
            <ion-select label="City" interface="action-sheet" placeholder="City" [(ngModel)]="profile.CityId">
              <ion-select-option *ngFor="let t of lstCities" [value]="t.value">{{t.label}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item>
            <ion-input label="Zip" [(ngModel)]="profile.ZipCode" labelPlacement="floating"
              placeholder="Zip"></ion-input>
          </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion value="Service" [disabled]="!isEditMode">
        <ion-item slot="header" color="light">
          <ion-label>Service</ion-label>
        </ion-item>
        <div class="ion-no-padding" slot="content">
          <ion-item *ngIf="isCoordinator">
            <ion-select label=" Profile Status" interface="action-sheet" placeholder="Profile Status"
              [(ngModel)]="profile.AssignmentStatusId">
              <ion-select-option *ngFor="let t of lstProfileStatuses" [value]="t.value">{{t.label}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item *ngIf="isEditMode || (!isEditMode && profile.PriestId > 0)">
            <ion-select label="Confession Father" interface="action-sheet" placeholder="Confession Father"
              [(ngModel)]="profile.PriestId">
              <ion-select-option *ngFor="let t of lstPriests" [value]="t.value">{{t.label}}</ion-select-option>
            </ion-select>
          </ion-item>
          <ion-item *ngIf="isEditMode || (!isEditMode && profile.DeaconRankId > 0)">
            <ion-select label="Deacon Rank" interface="action-sheet" placeholder="Deacon Rank"
              [(ngModel)]="profile.DeaconRankId">
              <ion-select-option *ngFor="let t of lstDeaconRanks" [value]="t.value">{{t.label}}</ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </ion-accordion>
      <ion-accordion value="Comment" [disabled]="!isEditMode">
        <ion-item slot="header" color="light">
          <ion-label>Comment</ion-label>
        </ion-item>
        <div class="ion-no-padding" slot="content">
          <ion-item>
            <ion-input label="Comment" labelPlacement="floating" placeholder="Comment"
              [(ngModel)]="profile.Comment"></ion-input>
          </ion-item>
          <!-- *ngIf="userService.currentUser?.ProfileId === profile?.ProfileId"> -->
          <ion-item *ngIf="!isNewAppUser && userService.currentUser?.ProfileId === profile?.ProfileId">
            <ion-button (click)="deleteAccount()" class="full-width" color="danger">Delete
              Account</ion-button>
          </ion-item>
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </div>
</ion-content>